<i [ngClass]="['icon', icon()]" aria-hidden="true"></i>
<span>{{ text() }}</span>

@if (showButton()) {
  <div class="buttons">
    <iu-storekeeper-button [label]="'BackToTasks' | SKWTranslate" (onClick)="backToTasks($event)" />
    <iu-storekeeper-button [label]="'Print' | SKWTranslate" [type]="'outlined'" />
  </div>
}
